import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import PageStructure from 'flarum/forum/components/PageStructure';
import Alert from 'flarum/common/components/Alert';
import Button from 'flarum/common/components/Button';
import ContactHero from './ContactHero';
import ContactForm from './ContactForm';
import { denialKey, getContactPageConfig } from '../../common/config';
export default class ContactPage extends Page {
  config = getContactPageConfig();
  submitted = false;
  customCssElement = null;
  oninit(vnode) {
    super.oninit(vnode);
    this.config = getContactPageConfig();
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    this.injectCustomCss();
    app.setTitle(this.pageTitle());
    app.setTitleCount(0);
  }
  onremove(vnode) {
    this.customCssElement?.remove();
    this.customCssElement = null;
    super.onremove(vnode);
  }
  view() {
    const denial = denialKey(this.config);
    return m(PageStructure, {
      className: "ContactPage",
      hero: () => m(ContactHero, {
        title: this.pageTitle(),
        description: this.pageDescription()
      })
    }, m("div", {
      className: "ContactPage-card"
    }, denial ? this.renderDenial(denial) : this.submitted ? this.renderSuccess() : this.renderForm()));
  }
  renderForm() {
    return m(ContactForm, {
      config: this.config,
      onsuccess: () => this.onSubmitted()
    });
  }
  renderDenial(key) {
    return m("div", {
      className: "ContactPage-message"
    }, m(Alert, {
      type: "error",
      dismissible: false
    }, app.translator.trans(key, {}, true)), m("p", {
      className: "ContactPage-back"
    }, m("a", {
      href: app.route('index')
    }, app.translator.trans('core.forum.index.all_discussions_link'))));
  }
  renderSuccess() {
    const message = this.config.successMessage || app.translator.trans('cengizkemec-contact-page.forum.success_message', {}, true);
    return m("div", {
      className: "ContactPage-message",
      role: "status"
    }, m(Alert, {
      type: "success",
      dismissible: false
    }, message), m("div", {
      className: "ContactPage-actions"
    }, m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-paper-plane",
      onclick: () => {
        this.submitted = false;
        m.redraw();
      }
    }, app.translator.trans('cengizkemec-contact-page.forum.send_another', {}, true))));
  }
  onSubmitted() {
    this.submitted = true;
    m.redraw();
  }
  pageTitle() {
    return this.config.title || app.translator.trans('cengizkemec-contact-page.forum.page_title', {}, true);
  }
  pageDescription() {
    return this.config.description || app.translator.trans('cengizkemec-contact-page.forum.page_description', {}, true);
  }
  injectCustomCss() {
    const css = this.config.customCss?.trim();
    if (!css) {
      return;
    }
    document.getElementById('cengizkemec-contact-page-custom-css')?.remove();
    const style = document.createElement('style');
    style.id = 'cengizkemec-contact-page-custom-css';
    style.textContent = css;
    document.head.appendChild(style);
    this.customCssElement = style;
  }
}
flarum.reg.add('cengizkemec-contact-page', 'forum/components/ContactPage', ContactPage);